import React, { useState, useEffect, useCallback } from 'react';
import { SERVER_URL } from '../../../constants.js';
import StudentTabs from '../../TabComponent/StudentTabs.js';
import SearchList from '../../shared utils/SearchList.js';
import Scroll from '../../shared utils/Scroll.js';
import AddStudent from '../../AddsEdits/Student/AddStudent.js';
import FlightsAndStudentData from './FlightsAndStudentData.js';
import { jsonOr } from "../../../utils/http";

function StudentSearch({ selectedYear, showFinancials, openStudentId, clearOpenStudentId }) {
  const [searchField, setSearchField] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [students, setStudents] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [yearSelected] = useState([selectedYear]);
  const [campuses, setCampuses] = useState([]);

useEffect(() => {
    const token = sessionStorage.getItem("bearer");
    fetch(`${SERVER_URL}api/campuses/active`, {
        headers: { Authorization: `Bearer ${token}` }
    })
        .then((res) => jsonOr(res, []))
        .then((data) => setCampuses(data))
        .catch((err) => console.error("Failed to fetch campuses:", err));
}, []);


  const filteredPersons = students.filter(
    (person) =>
      person.studentName?.toLowerCase().includes(searchField.toLowerCase()) ||
      person.studentSurname?.toLowerCase().includes(searchField.toLowerCase()) ||
      person.mtRef?.toLowerCase().includes(searchField.toLowerCase()) ||
      person.studentNationality?.toLowerCase().includes(searchField.toLowerCase()) ||
      person.id.toString().includes(searchField.toLowerCase())
  );

  const handleCardClick = (person) => {
    setSelectedPerson(person);
    setSearchShow(false);
  };

  const handleSelectStudent = (studentId) => {
    const student = students.find((s) => s.id === studentId);
    if (student) {
      setSelectedPerson(student);
      setSearchShow(false);
    }
  };

  const handleCloseTabs = () => {
    setSelectedPerson(null);
    setSearchField("");
    if (typeof clearOpenStudentId === 'function') {
     clearOpenStudentId();
   }
    fetchData();
    setRefreshTrigger(prev => prev + 1); // Increment to trigger a refresh
  };

  const fetchData = () => {
    console.log("triggered fetch data: " + yearSelected);
    fetchStudents();
    };

  const searchList = () => {
    if (searchShow) {
      return (
        <Scroll>
          <SearchList
            filteredPersons={filteredPersons}
            handleCardClick={handleCardClick}
            maxCards={80}
          />
        </Scroll>
      );
    }
  };
  
  const fetchStudents = useCallback(() => {
    setStudents([]); // Clear the existing students data first
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/studentsBasicYear/${selectedYear}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return [];
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch students');
        }
      })
      .then((data) => {
        sessionStorage.setItem('students', JSON.stringify(data));
        setStudents(data);
      })
      .catch((err) => console.error(err));
  }, [selectedYear]);

  useEffect(() => {
    console.log("triggered fetch students: " + selectedYear);
    fetchStudents();
  }, [selectedYear, fetchStudents]);

  useEffect(() => {

      console.log(">>> openStudentId changed to:", openStudentId);
  console.log(">>> students array length:", students.length);
  // If you want to see the first few students:
  console.log(">>> students[0]?.id, students[0]?.studentId:", 
    students[0]?.id, students[0]?.studentId);


  
  if (openStudentId != null && students.length > 0) {
    const match = students.find(
      (s) => s.id === openStudentId || s.studentId === openStudentId
    );
    console.log(">>> find(s) result:", match);
    if (match) {
      handleSelectStudent(openStudentId);
    }
  }
}, [openStudentId, students]);

  //useEffect(() => {
    //console.log("Students List:", students);
    //console.log("Filtered Persons List:", filteredPersons);
  //}, [students, filteredPersons]);
  

  const handleChange = (e) => {
    setSearchField(e.target.value);
    setSearchShow(e.target.value !== "");
  };

  const handleReset = () => {
    setSearchField("");
    setSearchShow(false);
  };

  const showTabs = () => {
    if (selectedPerson !== null) {
      return <StudentTabs selectedPerson={selectedPerson} onClose={handleCloseTabs} showFinancials={showFinancials} selectedYear={selectedYear} />;
    }
    return null;
  };

  const addStudent = (student) => {
    const token = sessionStorage.getItem("bearer");
    return fetch(`${SERVER_URL}api/students`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(student)
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        alert('Something went wrong!');
        return null;
      }
    })
    .then(newStudent => {
      if (newStudent) {
        fetchData();
        setRefreshTrigger(prev => prev + 1); // Increment to trigger a refresh
        return newStudent.id;
      }
    })
    .catch(err => {
      console.error(err);
      return null; // Ensure the function always returns something
    });
  };

  return (
    <section className="garamond">
      <form onReset={handleReset}>
        <div className="pa2">
          <input
            className="pa3 bb br3 grow b--none bg-lightest-blue ma3"
            type="search"
            placeholder="Search by Name, Nationality, or Master Tracker ID..."
            style={{ width: "50%" }}
            value={searchField}
            onChange={handleChange}
          />
        </div>
        {searchList()}
        {showTabs()}
        <div>
          <AddStudent addStudent={addStudent} setRefreshTrigger={setRefreshTrigger} campuses={campuses}/>
          <p style={{ color: '#999999', fontSize: '10px' }}>
            Is authenticated: {sessionStorage.getItem('isAuthenticated').toString()}
          </p>
        </div>
       </form>
       <div>
          <FlightsAndStudentData handleSelectStudent={handleSelectStudent} yearSelected={selectedYear} refreshTrigger={refreshTrigger} campuses={campuses}/>
        </div>
    </section>
  );
}

export default StudentSearch;
